<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1xgNou/tc-custom/9781439672594.jpg?1705026083341" alt="This image is the cover for the book A History Lover's Guide to Bar Harbor, History & Guide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A History Lover's Guide to Bar Harbor, History & Guide
      </h1>
      <p class="bookDescription body article font2">
        <p>Bar Harbor has evolved from humble beginnings to become one of Maine's most popular destinations. This tour goes beyond the typical travel guide to explore its fascinating historical sites in detail. A trail of existing buildings and monuments provides a backdrop for an unconventional history of places, people and events, with many previously unpublished photographs and untold entertaining stories. Discover the changes wrought by the world wars, the Spanish influenza, Prohibition and the Fire of 1947. Tour the Way Bak Ball, La Rochelle, the Casino and the Wharf. From Bar Harbor's first African American sea captain to the story of the two Miss Shannons, author Brian Armstrong offers a fascinating look into the history behind some of Bar Harbor's most famous landmarks.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Armstrong, Deborah M. Dyer Curator BHHS
      </h2>
      
      <p class="authorDescription body article">Brian Armstrong was born in Flemington, New Jersey, and grew up in Stanton, New Jersey. He received a bachelor's degree in history and political science from American University in Washington, D.C. He lives now in Mount Laurel, New Jersey. Armstrong worked for forty years for various technology and staffing companies, including EDS, Kelly Services and International Technology Solutions Inc. He was president of the South River Historical & Preservation Society for ten years and is now the vice-president, Central Region, for the League of Historical Societies of New Jersey. He is an independent historian, researcher and author. In 2015, he cowrote the book South River with Stephanie Bartz and Nan Whitehead (Arcadia Publishing). Armstrong authored the book The Franklin Park Tragedy: A Forgotten Story of Racial Injustice in New Jersey in 2019 (The History Press). He also frequently writes articles for the Bar Harbor Historical Society in Bar Harbor, Maine, where his mother's family lived for several hundred years. Mr. Armstrong lectures on local history, World War I, the Spanish influenza and political history. He is a collector of U.S. presidential election memorabilia and is a member of American Political Items Collectors (APIC). He is married to Rosemarie Rufo Armstrong and is father of two daughters and one grandson.<br><br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ecfd55b